import script from "./Sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=390ffc36&lang=scss"
import "./Sidebar.vue?vue&type=style&index=1&id=390ffc36&lang=scss&scoped=true"

import exportComponent from "/home/nicolas-choquet/www/play-private-store/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-390ffc36"]])

export default __exports__